import {createDeferredPromise, DeferredPromise} from '@colonist/utils'

declare const turnstile: any

export class UITurnstile {
    private static isTurnstileLoaded: boolean = false
    private static preClearanceCookiePromise: DeferredPromise | undefined

    private static async generateClearanceCookie(): Promise<boolean> {
        await this.waitUntilTurnstileIsLoaded()

        return new Promise((resolve, reject) => {
            turnstile.reset()

            turnstile.execute('#turnstile-widget', {
                callback: (token: string, preClearanceObtained: boolean) => resolve(preClearanceObtained),
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'error-callback': reject,
            })
        })
    }

    static async getToken(): Promise<string> {
        await this.waitUntilTurnstileIsLoaded()

        return new Promise((resolve, reject) => {
            turnstile.reset()

            turnstile.execute('#turnstile-widget', {
                callback: (token: string) => resolve(token),
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'error-callback': reject,
            })
        })
    }

    static isChallengeResponse(responseHeaders: Record<string, any>): boolean {
        // https://developers.cloudflare.com/waf/reference/cloudflare-challenges/#detecting-a-challenge-page-response
        return responseHeaders['cf-mitigated'] == 'challenge'
    }

    static async obtainPreClearanceCookie(): Promise<void> {
        if(this.preClearanceCookiePromise != undefined) return this.preClearanceCookiePromise

        this.preClearanceCookiePromise = createDeferredPromise()

        // eslint-disable-next-line no-restricted-syntax
        void this.getClearanceCookie()
            .then(() => this.preClearanceCookiePromise?.resolve(), (error) => this.preClearanceCookiePromise?.reject(error))
            .finally(() => this.preClearanceCookiePromise = undefined)

        return this.preClearanceCookiePromise
    }

    private static async getClearanceCookie(): Promise<void> {
        const maxAttempts = 5
        let attempt = 1

        while(attempt <= maxAttempts) {
            try {
                const success = await this.generateClearanceCookie()
                if(success) return
            } catch(error) {
                if(attempt == maxAttempts) {
                    throw error
                }
            }

            attempt += 1
        }
    }

    private static async waitUntilTurnstileIsLoaded(): Promise<void> {
        if(this.isTurnstileLoaded) return

        const result = createDeferredPromise()

        setTimeout(() => {
            result.reject(new Error('Unable to load required script'))
        }, 5_000)

        const checkTurnstileLoaded = setInterval(() => {
            if(window['turnstile'] == undefined) return
            if(turnstile.loaded != true) return

            this.isTurnstileLoaded = true
            result.resolve()
        }, 5)

        void result.finally(() => clearInterval(checkTurnstileLoaded))

        return result
    }
}
